import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { purchaseorderservices } from "../../services/purchaseorderService";
import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { Submissionbtn } from "../../components/buttons";
import { useNavigate,useLocation } from "react-router";
import { useSelector } from 'react-redux';
import { useFormikContext,useFormik,Field,Formik,Form,FieldArray } from 'formik';
import {profileservices} from '../../services/profileServices';
import { Dropdown } from 'primereact/dropdown';
import {useStock} from '../../contexts/stockContexts'; 
import {HandleClose} from '../../helpers/formclose';

const Createpurchaseorder = () => {
  const toast = useRef(null);
  const unitreducer = useSelector((state)=>state.unitreducer);
  const currencyreducer = useSelector((state)=>state.currencyreducer);
  const navigate = useNavigate();
  const location = useLocation();
  const [units,setUnits] = useState([]);
  const [currencies,setCurrencies] = useState([]);
  const [components,setComponents] = useState({
    'ponumber':'',
    'unit': []
  });
  const [submitted,setSubmitted] = useState(true);
  
  const [rows,setRows] = useState([]); 
  const [supllierlist,setSupllierlist] = useState([]);
  const [supllierlistobj,setSupllierlistobj] = useState([]);
  const [shippingaddress,setShippingaddress] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const {updateStock,settingsdata,getSettingValue} = useStock();
  const [formData, setFormData] = useState({
    component: "",
    componentSkuCode: "",
    componentType: "",
    description: "",
    supplier: "",
    cost: "",
    stockLevel: "",
    freightCharges: "",
    unitOfMeasurement: "",
    superdrugSkuCode: "",
    notes: "",
    supplier_cost:""
  });

  const countries = [
        { name: 'Australia', code: 'AU' },
        { name: 'Brazil', code: 'BR' },
        { name: 'China', code: 'CN' },
        { name: 'Egypt', code: 'EG' },
        { name: 'France', code: 'FR' },
        { name: 'Germany', code: 'DE' },
        { name: 'India', code: 'IN' },
        { name: 'Japan', code: 'JP' },
        { name: 'Spain', code: 'ES' },
        { name: 'United States', code: 'US' }
  ];

  useEffect(()=>{
    getunits();
    getsupplier();
    getcurrency();
    setComponents((prevData) => {
      return{
        ...prevData,
        podate: new Date().toISOString().slice(0, 10),
        currency:getSettingValue('default_currency'),
        status:'open',
        ponumber:'PO-'+Math.random(),
        unit:[],
        totalcost:[]
      }
    });
    getprofiles();
},[]);


useEffect(() => {
  if (location.state?.message) {
    // toast.info(location.state.message);
    toast.current.show({ severity: 'info', summary: 'Component', detail: location.state.message }); 
  }
}, [location]);

  

  const getunits = () =>{
    unitreducer.then((response)=>{
        //  console.log(response);
         setUnits(response);
      }).catch((error)=>{
          
      });
  }
  const getsupplier = () =>{
    supplierservices.getbulkdata('active',1,100).then((response)=>{
      console.warn(response);
        if(response.status ==200){
            setSupllierlist(response.data.data); 
            let supplierobjdata = [];
            response.data.data.forEach((value,index)=>{
              let supplobj =  { name: value.name, code: value.id };
              supplierobjdata.push(supplobj); 
            });
            setSupllierlistobj(supplierobjdata);
        }else{
            setSupllierlist([]); 
        }
      }).catch((error)=>{
            setSupllierlist([]); 
      });
  }

  const displayunits = () =>{
    let temparr = [];
    units.forEach((value,index)=>{
        temparr.push(<option value={value.short_code}>{value.name}</option>)     
    });
    return temparr; 
  }
  const handleClose = () => {
    // Handle close action here
  };

 
    function displaySupplier2(){
      let supllierdata = [];
      let supplierobjdata = [];
      supllierlist.forEach((value,index)=>{
        supllierdata.push(<option value={value.id}>{value.name}</option>); 
        
      });
      return supllierdata;
   }

   const getcurrency = () => {
    currencyreducer.then((response)=>{
        setCurrencies(response);
      }).catch((error)=>{
    });
   } 

   const displayCurrency = () => {
    let items = [];
    currencies.forEach((value,index)=>{
       items.push(<option key={index} value={value.code}>{value.name}</option>);
    })  
    return items;
  }


  const getcomponents = (id) =>{
       productservices.getcomponentsviasupplier(id).then((response)=>{
            if(response.status == 200){
              let objdata = response.data.data; 
                setComponents((prevData) => {
                  return{
                    ...prevData,
                    ...objdata,
                    
                  }
                });
                // setComponents(response.data.data);
                setRows(response.data.data.component);
            }else{
                // setComponents((prevData) => {
                //   return{
                //     ...prevData,
                //     }
                // });
                // setComponents([]);
                setRows([]);
            }
       }).catch((error)=>{
            
       }) 
  }

  const handleSave = (values) =>{
    if(values.length <= 0){
         toast.current.show({ severity: 'error', summary: 'Component', detail: "No data found" });
         return;     
    }
    setSubmitted(false);
    purchaseorderservices.createpurchaseorder(values).then((response)=>{  
      if(response.status ==200){
          setSubmitted(true);
          toast.current.show({ severity: 'success', summary: 'Component', detail: response.data.data }); 
          setTimeout(()=>{
            navigate(-1);
          },1000)
      }else{
          setSubmitted(true);
          toast.current.show({ severity: 'error', summary: 'Component', detail: response.data.data }); 
      }
    }).catch((error)=>{
        setSubmitted(true);
        toast.current.show({ severity: 'Error', summary: 'Component', detail: 'Error' }); 
    })
  }
 

  const getprofiles = () =>{
      profileservices.getprofile().then((response)=>{
        if(response.status == 200){
           setShippingaddress(response.data.data.shippingaddress);
        }  
      }).catch((error)=>{
          console.log("error"); 
      })
  }

  const displayshipping = () =>{
     let item = [];
     shippingaddress?.forEach((value)=>{
        let shippingmerge = value.line+','+value.city+','+value.state+','+value.country;
        item.push(<option value={value.id}>{shippingmerge}</option>);  
     }) 
     return item;
  }
  


  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Purchase / create purchase order"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        {/* <Titlebar text={"Create Purchase Order"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>

                <Formik
                        initialValues={
                              components
                        }
                        enableReinitialize={true}
                        onSubmit={ (values) => {
                            handleSave(values);
                        }}
                 >
                    {({ handleChange, setFieldValue,values }) => ( 
                 <Form>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label>Supplier</label>
                      {/* <Field as="select" className="form-control" required name="supplier_id" 
                        onChange={(e) => {
                        const { name, value } = e.target;
                           getcomponents(value);
                        }}>
                        <option value="">Select Supplier</option>
                        {displaySupplier2()} 
                       </Field> */}

                        <Dropdown value={selectedSupplier} onChange={(e) => {
                          const { name, value } = e.target;
                          // console.log(value);
                          getcomponents(value.code); 
                          setFieldValue('supplier_id',e.target);
                          setSelectedSupplier(e.value)}} options={supllierlistobj} optionLabel="name" placeholder="Select a Supplier" 
                        filter required name="supplier_id"  className="w-100" />

                    </div>
                    <div className="col-md-6 form-group">
                      <label>Purchase Order Date</label>
                      <Field
                        type="date"
                        name="podate"
                        className="form-control"
                        placeholder="Select Date"
                        required
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Po No.</label>
                      <Field
                        type="text"
                        name="ponumber"
                        className="form-control"
                        placeholder="Po number"
                        required
                        onChange={(e) =>{
                            setFieldValue('ponumber',e.target.value); 
                            setComponents((prevData)=>{
                                return {
                                   ...prevData,
                                   ponumber:e.target.value
                                }  
                            })
                         }}
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label><i className="fa fa-address"></i> Shipping Address</label>
                      <Field as="select" className="form-control" name="shipping_address" required
                         onChange={(e) =>{
                            setFieldValue('shipping_address',e.target.value); 
                            setComponents((prevData)=>{
                                return {
                                   ...prevData,
                                   shipping_address:e.target.value
                                }  
                            })
                         }}
                      >
                              <option value="">Select Shipping Address</option>  
                              {displayshipping()}
                       </Field>
                    </div>

                    <div className="col-md-4 form-group">
                      <label>Expected Delivery Date</label>
                      <Field
                        type="date"
                        name="expecteddldate"
                        className="form-control"
                        placeholder="Expected Delivery Date"
                        required
                        onChange={(e) =>{
                            setFieldValue('expecteddldate',e.target.value); 
                            setComponents((prevData)=>{
                                return {
                                   ...prevData,
                                   expecteddldate:e.target.value
                                }  
                            })
                         }}
                      />
                    </div>

                    <div className="col-md-4 form-group">
                      <label>Currency</label>
                        <Field as="select" className="form-control" name="currency" required
                           onChange={(e) =>{
                            setFieldValue('currency',e.target.value); 
                            setComponents((prevData)=>{
                                return {
                                   ...prevData,
                                   currency:e.target.value
                                }  
                            })
                         }}
                        >
                               {displayCurrency()}
                       </Field>
                    </div>

                    <div className="col-md-4 form-group">
                      <label>Status</label>
                      <Field
                        as="select"
                        name="status"
                        className="form-control"
                        onChange={(e) =>{
                            setFieldValue('status',e.target.value); 
                            setComponents((prevData)=>{
                                return {
                                   ...prevData,
                                   status:e.target.value
                                }  
                            })
                         }}
                      >
                        <option value="open">Open</option> 
                        <option value="pending">Pending</option>
                        <option value="dispatched">Dispatched</option>
                        <option value="partially_received">Partially Received</option>
                        <option value="fully_received">Fully Received</option>
                      </Field>
                    </div>
                    <br/>
                    <h4 className="text-success pt-3">Components : </h4>
                    {rows.map((row, index) => (
                        <div key={row.id} className="flex items-center m-1">
                            <div className='row'>

                            <div className="col-md-1 form-group">
                                 <Label name="id" />
                                
                                 <Field
                                    type="text"
                                    name={`id[${index}]`}
                                    // value={components[index].id}
                                    className="form-control"
                                    readOnly
                                    
                                 />
                            </div>

                            <div className="col-md-3 form-group">
                                 <Label name="Compoent" />
                                 <Field type="text" 
                                 name={`component[${index}]`}
                                //  value={row.component} 
                                 className="form-control" 
                                 readOnly
                                 />
                            </div>

                            <div className="col-md-2 form-group">
                                 <Label name="Sku Code" />
                                
                                 <Field type="text" 
                                 name={`componentSkuCode[${index}]`}
                                //  value={row.componentSkuCode} 
                                 className="form-control" 
                                 readOnly
                                 />
                            </div>
                            <div className="col-md-1 form-group">
                                 <Label name="Unit"/>
                                 <Field as="select" name={`unit[${index}]`} className="form-control"
                                    onChange={(e) =>{
                                        setFieldValue(`unit[${index}]`,e.target.value); 
                                        setComponents((prevData) => {
                                          const unitdata = Array.isArray(prevData.unit) ? [...prevData.unit] : [];
                                          unitdata[index] = e.target.value;
                                          // const unitdata = [...prevData.unit];
                                          // unitdata[index] = e.target.value;

                                          return {
                                            ...prevData,
                                            unit: unitdata
                                          };
                                        });
                                    }}
                                 >
                                    <option value="">Select Unit</option>
                                    {displayunits()}
                                </Field>
                                
                            </div>
                            <div className="col-md-2 form-group">
                                 <Label name="Required Quantity" />
                                  <Field type="number" 
                                   name={`quantity[${index}]`}
                                   className="form-control"
                                   
                                   onChange={(e) =>{
                                        setFieldValue(`quantity[${index}]`,e.target.value); 
                                        setComponents((prevData) => {
                                          const updatedQuantities = Array.isArray(prevData.quantity) ? [...prevData.quantity] : [];
                                          // const updatedQuantities = [...prevData.quantity];
                                          updatedQuantities[index] = e.target.value;

                                          return {
                                            ...prevData,
                                            quantity: updatedQuantities
                                          };
                                        });
                                    }}
                                 />
                            </div>

                            <div className="col-md-1 form-group">
                                 <label>Unit price </label>
                                  <Field type="number" 
                                   name={`unitprice[${index}]`}
                                   className="form-control"
                                   step="any"
                                   onChange={(e) => {
                                      setFieldValue(`unitprice[${index}]`,e.target.value);
                                      let quantity = values.quantity[index];
                                      let total_cost = (quantity * e.target.value);
                                      setFieldValue(`totalcost[${index}]`,total_cost);

                                       setComponents((prevData) => {
                                          const unitprice = Array.isArray(prevData.unitprice) ? [...prevData.unitprice] : [];
                                          // const unitprice = [...prevData.unitprice];
                                          unitprice[index] = e.target.value;


                                          const totalcost = Array.isArray(prevData.totalcost) ? [...prevData.totalcost] : [];
                                          // const totalcost = [...prevData.totalcost];
                                          totalcost[index] = total_cost;
                                          return {
                                            ...prevData,
                                            unitprice: unitprice,
                                            totalcost:totalcost
                                          };
                                        });
                                     // e.target.value;  
                                   }}
                                 />
                            </div>

                            <div className="col-md-2 form-group">
                                 {/* <Label name="Total cost" /> */}
                                 <label>Total cost </label>
                                  <Field type="number" 
                                   name={`totalcost[${index}]`}
                                   className="form-control" 
                                   disabled
                                 />
                            </div>

                            

                            {/* <div className="col-md-3 form-group">
                                <Label name="Select Unit"/>
                                <Field type="number" name={`quantity[${index}]`} className="form-control"
                    placeholder="Enter Quantity" required/>
                            </div>

                            <div className="col-md-3 form-group">
                                <Label name="Enter Quantity"/>  
                                <Field type="number" name={`quantity[${index}]`} className="form-control"
                    placeholder="Enter Quantity" required/>
                            </div> */}
                          </div>
                        </div>
                    ))}
                 </div>

                  <br></br>
                  <br></br>
                  <div className="row">
                    <div className="col-md-6">
                       <Submissionbtn issaved={submitted}/>
                      {/* <button
                        type="submit"
                        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                        // onClick={handleSave}
                      >
                        Save
                      </button> */}
                    </div>

                     {<HandleClose/>}
                  </div>
                   </Form>
                    )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );


  
};

export default Createpurchaseorder;
